/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html } from 'lit-all'
import styles from 'lib-styles'
import * as paths from 'lib-paths'
/* eslint-disable import/no-unresolved */

class HHCollectionSort extends BaseElement {
  static properties = {
    products: { type: Array },
    filters: { type: Object },
    opened: { type: Boolean, reflect: true },
  }

  constructor() {
    super()
    this.opened = false
    this._handleClickOutside = this._handleClickOutside.bind(this)
    this.sortOptions = [
      // TODO: implement featured and best-selling sort
      // { value: 'featured', title: 'Featured' },
      // { value: 'best-selling', title: 'Best selling' },
      { value: 'title-ascending', title: 'Alphabetically, A-Z' },
      { value: 'title-descending', title: 'Alphabetically, Z-A' },
      { value: 'price-ascending', title: 'Price, low to high' },
      { value: 'price-descending', title: 'Price, high to low' },
      { value: 'published-ascending', title: 'Date, old to new' },
      { value: 'published-descending', title: 'Date, new to old' },
    ]
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('click', this._handleClickOutside)
    document.addEventListener('keydown', this._handleEscapeToClose)
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._handleClickOutside)
    document.removeEventListener('keydown', this._handleEscapeToClose)

    super.disconnectedCallback()
  }

  open() {
    this.opened = true
  }

  close() {
    this.opened = false
  }

  toggle() {
    this.opened = !this.opened
  }

  _updateSort(value) {
    const url = new URL(window.location.href)
    url.searchParams.set('sort', value)
    window.history.replaceState(null, null, url.toString())
    this.dispatchEvent(new Event('change'))
    this.close()
  }

  _handleClickOutside = (event) => {
    if (!event.composedPath().includes(this)) {
      this.close()
    }
  }

  _handleEscapeToClose = (event) => {
    if (event.key !== 'Escape') return
    this.close()
  }

  _handleKeyDownSelect(event, option) {
    if (event.key !== 'Enter') return
    this._updateSort(option)
  }

  render() {
    return html`
      <div class="container">
        <button type="button" @click=${this.toggle} id="toggle">
          <span> Sort By </span>
          <span class="chevron">${paths.sortChevron}</span>
        </button>
        <div class="popover">
          <ul class="popover__list">
            ${this.sortOptions?.map(
              (option) => html`
                <li
                  class="popover__item"
                  @click=${() => this._updateSort(option.value)}
                  @keydown=${(event) =>
                    this._handleKeyDownSelect(event, option)}
                  tabindex="0"
                >
                  <span>${option.title}</span>
                </li>
              `
            )}
          </ul>
        </div>
        <slot></slot>
      </div>
    `
  }

  static styles = [
    styles.reset,
    styles.flex,
    styles.typography,
    css`
      :host {
        display: block;
        height: 100%;
      }
      header {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;
      }
      #toggle {
        background: none;
        cursor: pointer;
        font-family: 'PP Right Grotesk', sans-serif;
        font-size: 14px;
        font-weight: 500;
        height: 100%;
        line-height: 16px;
        transition: opacity 0.3s ease-out;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 4px 0;
      }
      #toggle span {
        font-family: Inter, sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--black);
      }
      #toggle:hover {
        opacity: 1;
      }
      #toggle .chevron {
        width: 15px;
        height: 7.5px;
        display: inline-block;
        line-height: 0;
      }
      #toggle .chevron svg {
        width: 100%;
        height: 100%;
        transition: all 0.2s linear;
      }
      :host([opened]) #toggle .chevron svg {
        transform: rotate(180deg);
      }
      .container {
        height: 100%;
        position: relative;
      }
      :host([opened]) .popover {
        opacity: 1;
        pointer-events: all;
      }
      button {
        padding: 0;
      }
      .popover {
        background: white;
        border: 1px solid #dbdbdb;
        box-shadow: 2px 2px 6px rgb(var(--black, #35332b) / 0.05);
        color: rgb(var(--black, #35332b));
        inset-inline-end: 0;
        list-style: none;
        margin: auto;
        max-width: 200px;
        width: 200px;
        max-height: min(60vh, max-content);
        opacity: 0;
        position: absolute;
        pointer-events: none;
        text-align: right;
        transition: opacity 0.3s ease-out;
        z-index: 99;
      }
      .popover__list {
        display: flex;
        flex-direction: column;
      }
      .popover__item {
        color: var(--black, black);
        cursor: pointer;
        padding: 8px;
      }
      .popover__item span {
        font-family: Inter, sans-serif;
        font-weight: 500;
        font-size: 14px;
      }
      .popover__item:hover {
        background-color: #ebe9e9;
        transition: all 0.3s ease-out;
      }
    `,
  ]
}

customElements.define('hh-collection-sort', HHCollectionSort)
